/**
 * Created by woo on 01/06/2017.
 */

import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actions from './action'
import {  Button } from 'antd'
import LoginPage from '../../assert/images/login-page.jpg'
import './style.css'

class Portal extends React.Component {
  static defaultProps = {
    portal: {}
  };


  componentDidMount() {
    this.checkHttps()
    this.props.fetchPortal()
  }

  checkHttps = () => {
    const https = window.location.protocol === 'https:'
    const url = window.location.host
    if (process.env.NODE_ENV !== 'development' && !https) {
      window.location.href = 'https://' + url
    }
  };

  render() {
    return (
      <div>
          <div>
            <img src={LoginPage?LoginPage:""} alt='' style={{ height: '100vh', width: '100vw' }} />
          </div>
        <Button ghost className='login-btn' style={{ width: '150px' }}>
          <a href={this.props.portal.redirect}>登录</a>
        </Button>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    portal: state.getPortal.portal,
  }
}
export default withRouter(connect(mapStateToProps, actions)(Portal))



// WEBPACK FOOTER //
// ./src/containers/Portal/index.js